import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const AvailabilityDowntime = ({ externalData }) => {
  const { t } = useTranslation();

  const processedData = React.useMemo(() => {
    const data = externalData.Objetivo;
    let arrayRows = [];
    let noMonCum = 0;
    let downCum = 0;

    let global = data?.Global || [];

    global.forEach((ele) => {
      ele.estado.forEach((states) => {
        if (states.nombre === 'no monitoreo' || states.nombre === 'downtime') {
          let monCum = {};
          let duration =
            moment(states.fecha_hasta) - moment(states.fecha_desde);
          monCum['tiempo_duracion'] = duration;
          let date = states.fecha_desde.substring(0, 10);
          let name = states.nombre;
          let begin = states.fecha_desde.substring(11, 19);
          let final = states.fecha_hasta.substring(11, 19);

          let durationStr = new Date(duration).toISOString().substring(11, 19);

          monCum['duracion'] = durationStr;
          monCum['fecha'] = date;
          monCum['hora_inicio'] = begin;
          monCum['hora_termino'] = final;
          monCum['fecha_inicio'] = moment(states.fecha_desde);
          monCum['fecha_termino'] = moment(states.fecha_hasta);
          monCum['fechaStrInicio'] = states.fecha_desde;
          monCum['fechaStrTermino'] = states.fecha_hasta;
          monCum['nombre'] = name;

          if (durationStr !== '00:00:00') {
            arrayRows.push(monCum);
          }
        }
      });
    });

    arrayRows.sort((a, b) => a.fecha_inicio - b.fecha_inicio);

    if (arrayRows.length > 0) {
      noMonCum = arrayRows.reduce(
        (sum, value) =>
          value.nombre === 'no monitoreo' ? sum + value.tiempo_duracion : sum,
        0
      );
      noMonCum = new Date(noMonCum).toISOString().substring(11, 19);

      let downCumVal = arrayRows.reduce(
        (sum, value) =>
          value.nombre === 'downtime' ? sum + value.tiempo_duracion : sum,
        0
      );
      if (downCumVal < 86400000) {
        downCum = new Date(downCumVal).toISOString().substring(11, 19);
      } else {
        let hhmmss = new Date(downCumVal).toISOString().substring(11, 19);
        let days = Math.floor(downCumVal / 1000 / 60 / 60 / 24);
        downCum = `${days} día(s) ${hhmmss}`;
      }
    } else {
      noMonCum = 0;
      downCum = 0;
    }

    return {
      rows: arrayRows,
      noMonCum,
      downCum,
    };
  }, [externalData]);

  const { rows, noMonCum, downCum } = processedData;

  return (
    <div>
      <TableData
        rows={rows}
        name={t('availability.name-graph.10')}
        noMonCum={noMonCum}
        downCum={downCum}
        t={t}
      />
    </div>
  );
};

function TableData({ rows, name, noMonCum, downCum, t }) {
  return (
    <Table id="table_0" aria-label="spanning table">
      <TableHead>
        <TableRow>
          <TableCell colSpan={5}>{name}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {t('availability-downtime.table.header.start-date')}
          </TableCell>
          <TableCell>
            {t('availability-downtime.table.header.start-time')}
          </TableCell>
          <TableCell>
            {t('availability-downtime.table.header.end-time')}
          </TableCell>
          <TableCell>
            {t('availability-downtime.table.header.duration')}
          </TableCell>
          <TableCell>{t('availability-downtime.table.header.type')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.fecha}</TableCell>
            <TableCell>{row.hora_inicio}</TableCell>
            <TableCell>{row.hora_termino}</TableCell>
            <TableCell>{row.duracion}</TableCell>
            <TableCell>
              {t(`availability-downtime.states.${row.nombre}`)}
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell rowSpan={3} />
          <TableCell colSpan={3}>
            {t('availability-downtime.table.footer.total-downtime')}
          </TableCell>
          <TableCell>{downCum}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={3}>
            {t('availability-downtime.table.footer.total-no-monitoring')}
          </TableCell>
          <TableCell>{noMonCum}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default AvailabilityDowntime;
